import styled from 'styled-components';
import { ModalFeaturesStyled } from '../ModalFeaturesStyled';
import { rem } from 'polished';

export const ModalFeaturesStyledOV = styled(ModalFeaturesStyled)`
    .categories {
        span {
            &.selected {
                background: ${({ theme }) => theme.colors.primary};
                color: ${({ theme }) => theme.colors.black};
                border-color: ${({ theme }) => theme.colors.primary};
                font-weight: bold;
            }
            &:hover {
                background: ${({ theme }) => theme.colors.white};
                color: ${({ theme }) => theme.colors.black};
                border-color: ${({ theme }) => theme.colors.black};
            }
        }
    }

    .engines,
    .colors,
    .interiors,
    .features {
        .label {
            font-size: ${({ theme }) => theme.fontSizes.h4};
        }
    }

    .colors {
        .configurations {
            button {
                &.selected,
                &:hover {
                    box-shadow: 0px 0px 0px 0.1rem ${({ theme }) => theme.colors.black};
                }
            }
        }
    }

    .engines {
        .configurations {
            > div {
                .configuration {
                    font-weight: ${({ theme }) => theme.fontWeights.textBold};
                }

                .engine,
                .price {
                    color: ${({ theme }) => theme.colors.grey31};
                }
            }
        }
    }
`;
